export enum CitationFileFormat {
  RIS = 'ris',
  PUBMED = 'pubmed',
  HARVARD_CITATION = 'harvard-citation',
  CLINICAL_TRIALS_GOV_JSON = 'clinical-trials-gov-json',
}
